export default __webpack_public_path__ + "static/media/Strategy.20278ad5.svg";